import React, { useEffect } from 'react';
import './App.css';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProblemSolution from './components/ProblemSolution';
import Platform from './components/Platform';
import CompanyVideo from './components/CompanyVideo';
// eslint-disable-next-line
import Market from './components/Market';
// eslint-disable-next-line
import BusinessModel from './components/BusinessModel';
import Traction from './components/Traction';
import Team from './components/Team';
import Roadmap from './components/Roadmap';
import Gallery from './components/Gallery';
import PitchDeck from './components/PitchDeck';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

import { trackPageView } from './analytics';

export default function App() {
  useEffect(() => {
    trackPageView('Inivayal Agritech — Home');
  }, []);

  return (
    <div className="app">
      <Navbar />
      <main>
        <Hero />
        <ProblemSolution />
        <Platform />
        <CompanyVideo />
        {/* <Market />
        <BusinessModel /> */}
        <Traction />
        <Team />
        <Roadmap />
        <Gallery />
        <PitchDeck />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
